'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isContactAssociationMessage = undefined;

var _messageTypes = require('../constants/messageTypes');

var _isType = require('./isType');

var isContactAssociationMessage = exports.isContactAssociationMessage = (0, _isType.isType)(_messageTypes.CONTACT_ASSOCIATION);